import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import logo1 from "../../assets/logo1.png";
import FreeTrialModal from "../FreeTrialModal";

const Blog = () => {
  const [showTrial, setShowTrial] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const blogs = [
    {
      id: 1,
      title: "Best AI Recruitment Software for HR Teams in 2025",
      slug: "best-ai-recruitment-software-2025",
      description:
        "Complete buyer’s guide to choosing the best AI recruitment software for HR teams in 2025.",
      date: "Mar 8, 2025",
    },
    {
      id: 2,
      title: "How AI Resume Screening Works in 2025",
      slug: "how-ai-resume-screening-works-2025",
      description:
        "Discover how AI-powered resume screening transforms hiring processes in 2025.",
      date: "Dec 5, 2025",
    },
    {
      id: 3,
      title: "Top 5 AI Hiring Trends in 2025",
      slug: "top-5-ai-hiring-trends-2025",
      description:
        "Explore the most impactful AI recruitment trends shaping hiring in 2025.",
      date: "Dec 10, 2025",
    },
    {
      id: 4,
      title: "Reduce Hiring Bias with AI Tools",
      slug: "reduce-hiring-bias-ai-tools",
      description:
        "Learn how AI ensures fair and unbiased candidate selection in modern recruitment.",
      date: "Dec 12, 2025",
    },
    {
      id: 5,
      title: "AI Recruitment Statistics You Must Know in 2025",
      slug: "ai-recruitment-statistics-2025",
      description:
        "Explore key AI recruitment stats shaping hiring trends in 2025.",
      date: "Dec 15, 2025",
    },
    {
      id: 6,
      title: "The Future of AI in HR: 2025 and Beyond",
      slug: "future-of-ai-in-hr-2025",
      description:
        "Learn how AI is transforming HR and what the future holds for recruitment processes.",
      date: "Dec 18, 2025",
    },
    {
      id: 7,
      title: "Choosing the Right AI Hiring Software for Your Business",
      slug: "choosing-right-ai-hiring-software",
      description:
        "A guide to selecting the best AI recruitment platform tailored for your company’s needs.",
      date: "Dec 20, 2025",
    },
  ];

  return (
    <div style={{ background: "#f8f9fa" }}>
      {/* SEO */}
      <Helmet>
        <title>Blog | The AI Recruiter</title>
        <meta
          name="description"
          content="Read AI recruitment insights, trends, and tips for smarter hiring."
        />
        <link rel="canonical" href="https://theairecruiter.ai/blog" />
      </Helmet>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg bg-white shadow-sm sticky-top">
        <div className="container">
          <Link className="navbar-brand mx-auto" to="/home">
            <img src={logo1} alt="logo" style={{ height: "50px" }} />
            <span className="web-name ms-2">Screenify</span>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarNav"
          >
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/ai-recruiter">
                  AI Recruiter
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About us
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link active fw-semibold" to="/blog">
                  Blog
                </Link>
              </li>

              {/* <li className="nav-item">
                <button
                  className="btn btn-warning"
                  onClick={() => setShowTrial(true)}
                >
                  Free Trial
                </button>
                <FreeTrialModal
                  show={showTrial}
                  onClose={() => setShowTrial(false)}
                />
              </li> */}
            </ul>

            <ul className="navbar-nav ms-lg-auto mt-3 mt-lg-0 text-center">
              <li className="nav-item mb-2 mb-lg-0 me-lg-2">
                <button
                  className="btn btn-warning w-100 w-lg-auto"
                  onClick={() => setShowTrial(true)}
                >
                  Free Trial
                </button>
                <FreeTrialModal
                  show={showTrial}
                  onClose={() => setShowTrial(false)}
                />
              </li>

              <li className="nav-item mb-2 mb-lg-0 me-lg-2">
                <Link
                  className="btn btn-outline-primary w-100 w-lg-auto"
                  to="/login"
                >
                  Login
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="btn btn-outline-primary w-100 w-lg-auto"
                  to="/signup"
                >
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section
        className="text-white text-center py-5"
        style={{
          background: "linear-gradient(135deg, #007bff, #00c6ff)",
        }}
      >
        <div className="container">
          <h1 className="display-4 fw-bold animate__animated animate__fadeInDown">
            AI Recruitment Blog | AI Recruiter Insights – Screenify
          </h1>
          <p className="lead animate__animated animate__fadeInUp">
            Stay updated with AI hiring insights, trends & recruitment
            strategies.
          </p>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-5">
        <div className="container">
          <div className="row g-4">
            {blogs.map((blog) => (
              <div className="col-md-4" key={blog.id} data-aos="fade-up">
                <div
                  className="card h-100 rounded-4 shadow-sm hover-scale"
                  style={{
                    background: "rgba(255,255,255,0.7)",
                    backdropFilter: "blur(10px)",
                    border: "none",
                  }}
                >
                  {/* Premium SVG Placeholder */}
                  <div
                    style={{
                      height: "150px",
                      background:
                        "linear-gradient(135deg, rgba(0,123,255,0.3), rgba(0,198,255,0.3))",
                      borderTopLeftRadius: "1rem",
                      borderTopRightRadius: "1rem",
                    }}
                  ></div>

                  <div className="card-body d-flex flex-column">
                    <h5 className="fw-bold">{blog.title}</h5>
                    <p className="text-muted small">{blog.date}</p>
                    <p className="flex-grow-1">{blog.description}</p>
                    <Link
                      to={`/blog/${blog.slug}`}
                      className="btn btn-primary mt-auto"
                    >
                      Read More →
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-5 bg-dark">
        <div className="container text-center text-white">
          <h2
            className="fw-bold display-5"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Get in Touch
          </h2>
          <p className="mb-4" data-aos="fade-up" data-aos-delay="300">
            We’d love to hear from you! Reach out with any questions or
            feedback.
          </p>

          <div
            className="row g-4 justify-content-center"
            style={{ borderBottom: "2px solid rgba(255, 255, 255, 0.3)" }}
          >
            {[
              {
                title: "Call Us",
                icon: "fas fa-phone-alt",
                lines: ["+91 96115 12281", "+91 90083 09255"],
                color: "text-primary",
              },
              {
                title: "Email",
                icon: "fas fa-envelope",
                lines: ["contactus@archipeltechnologies.com"],
                color: "text-warning",
              },
              {
                title: "Follow Us",
                icon: "fas fa-share-alt",
                social: true,
              },
            ].map((item, i) => (
              <div
                className="col-md-4 mb-3"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 200}
              >
                <div
                  className="p-4 rounded-4 shadow text-center hover-scale"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <i className={`${item.icon} fa-3x mb-3 ${item.color}`}></i>
                  <h5 className="fw-bold mb-3">{item.title}</h5>

                  {item.social ? (
                    <div>
                      <a href="#" className="me-3">
                        <i className="fab fa-linkedin fa-2x text-primary"></i>
                      </a>
                      <a href="#" className="me-3">
                        <i
                          className="fab fa-instagram fa-2x"
                          style={{ color: "#E4405F" }}
                        ></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-youtube fa-2x text-danger"></i>
                      </a>
                    </div>
                  ) : (
                    item.lines.map((line, idx) => (
                      <p key={idx} className="mb-1">
                        {item.icon === "fas fa-envelope" ? (
                          <a
                            href={`mailto:${line}`}
                            className="text-decoration-none text-white"
                          >
                            <i className={`${item.icon} me-2 text-warning`}></i>
                            {line}
                          </a>
                        ) : (
                          <a
                            href={`tel:${line}`}
                            className="text-decoration-none text-white"
                          >
                            <i className={`${item.icon} me-2 text-primary`}></i>
                            {line}
                          </a>
                        )}
                      </p>
                    ))
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        className="bg-white text-dark py-3"
        // style={{
        //   background: "linear-gradient(90deg, #007bff, #00c6ff)",
        // }}
      >
        <div className="container d-flex justify-content-between">
          <p className="m-0">
            © Copyright {new Date().getFullYear()} Archipel Technlogies Pvt Ltd.
            . All Rights Reserved.
          </p>

          <div>
            <Link className="text-dark me-3" to="/privacy-policy">
              Privacy & Cookies
            </Link>
            <Link className="text-dark" to="/terms-and-conditions">
              Terms of Use
            </Link>
          </div>
        </div>
      </footer>

      <style>{`
        .hover-scale:hover {
          transform: translateY(-6px);
          transition: 0.3s;
        }
      `}</style>
    </div>
  );
};

export default Blog;
